var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResearchGalleryPage',{attrs:{"page-title":_vm.pageTitle,"section-label":"领导关怀","section-route":_vm.sectionRoute,"top-strip-image":_vm.topStripImage,"hero-background-image":_vm.heroBackgroundImage,"groups":_vm.visibleGroups}})
}
var staticRenderFns = []

export { render, staticRenderFns }